import gql from 'graphql-tag';

const GET_PROJECT_TEMPLATES = gql`
  query {
    getProjectTemplates {
      templateId
      name
      description
      scheduledStartDate
      dueDate
      attachments {
        fileName
        originalFileName
        fileSize
        # applicable only for inline image upload like profile pic, logo, ...
        # downloadURL
      }
      milestones {
        milestoneOrder
        milestoneId
        name
        tasks {
          taskOrder
          taskTemplateId
          title
          technician {
            userId
            name
            email
            firstName
            lastName
          }
          techGroup {
            name
            groupId
          }
          description
          estimatedTime
          scheduledStartDate
          dueDate
        }
      }
      tasks {
        taskOrder
        taskTemplateId
        technician {
          userId
          name
          email
          firstName
          lastName
        }
        techGroup {
          name
          groupId
        }
        title
        description
        estimatedTime
        scheduledStartDate
        dueDate
      }
    }
  }
`;

const GET_PROJECT_TEMPLATE_ID_LIST = gql`
  query {
    getProjectTemplates {
      templateId
      name
    }
  }
`;

const GET_PROJECT_TEMPLATE_FORM = gql`
  query($input: ProjectTemplateIdentifierInput!) {
    getProjectContentFromTemplate(input: $input) {
      title
      description
      scheduledStartDate
      dueDate
      attachments {
        fileName
        originalFileName
        fileSize
      }
      milestones {
        name
        milestoneOrder
        tasks {
          title
          taskOrder
          description
          technician {
            userId
            name
            email
            firstName
            lastName
          }
          techGroup {
            name
            groupId
          }
          estimatedTime
          scheduledStartDate
          dueDate
        }
      }
      tasks {
        title
        taskOrder
        description
        technician {
          userId
          name
          email
          firstName
          lastName
        }
        techGroup {
          name
          groupId
        }
        estimatedTime
        scheduledStartDate
        dueDate
      }
    }
  }
`;

const GET_PROJECT_TEMPLATE = gql`
  query($input: ProjectTemplateIdentifierInput!) {
    getProjectTemplate(input: $input) {
      templateId
      name
      description
      scheduledStartDate
      dueDate
      attachments {
        fileName
        originalFileName
        fileSize
        # applicable only for inline image upload like profile pic, logo, ...
        # downloadURL
      }
      milestones {
        milestoneId
        milestoneOrder
        name
        tasks {
          taskTemplateId
          taskOrder
          technician {
            userId
            name
            email
            firstName
            lastName
          }
          techGroup {
            name
            groupId
          }
          title
          description
          estimatedTime
          scheduledStartDate
          dueDate
        }
      }
      tasks {
        taskTemplateId
        taskOrder
        technician {
          userId
          name
          email
          firstName
          lastName
        }
        techGroup {
          name
          groupId
        }
        title
        description
        estimatedTime
        scheduledStartDate
        dueDate
      }
    }
  }
`;

const GET_PROJECT_CONTENT_FROM_TEMPLATE = gql`
  query($input: ProjectTemplateRefInput!) {
    getProjectContentFromTemplate(input: $input) {
      title
      description
      scheduledStartDate
      dueDate
      milestones {
        name
        tasks {
          title
          description
          technician {
            userId
            name
            email
            firstName
            lastName
          }
          techGroup {
            name
            groupId
          }
          estimatedTime
          scheduledStartDate
          dueDate
        }
      }
      tasks {
        title
        description
        technician {
          userId
          name
          email
          firstName
          lastName
        }
        techGroup {
          name
          groupId
        }
        estimatedTime
        scheduledStartDate
        dueDate
      }
      attachments {
        fileName
        originalFileName
        fileSize
        # applicable only for inline image upload like profile pic, logo, ...
        # downloadURL
      }
    }
  }
`;

export {
  GET_PROJECT_TEMPLATES,
  GET_PROJECT_TEMPLATE,
  GET_PROJECT_CONTENT_FROM_TEMPLATE,
  GET_PROJECT_TEMPLATE_FORM,
  GET_PROJECT_TEMPLATE_ID_LIST
};
